'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { Carousel } from '@zillow/constellation-10';
import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { FloorPlanCard } from './FloorPlanCard';
import { FloorPlanDots } from './FloorPlanDots';
import { useFloorPlanCarousel } from './hooks/useFloorPlanCarousel';
import type { Floorplan, Unit } from './UnitTable';
import * as styles from './unitsModule.styles';

type MobileFloorPlanCarouselProps = {
  floorplans: Array<Floorplan>;
  listing: PropertyDetailListing;
  onUnitSelect: (unit: Unit, floorplan: Floorplan) => void;
  onSeeAll: (floorplan: Floorplan) => void;
};

export const MobileFloorPlanCarousel = ({
  floorplans,
  listing,
  onUnitSelect,
  onSeeAll,
}: MobileFloorPlanCarouselProps) => {
  const t = useTranslations('hdp');
  const { carousel, currentSlide, goToSlide } = useFloorPlanCarousel();

  return (
    <>
      <Carousel.ScrollContainer
        ref={carousel.scrollContainer}
        onScroll={carousel.handleOnScroll}
        onKeyUp={carousel.scrollToFocusedEl}
        enableSnap
        slideGap="md"
        aria-label={t('floorPlans')}
      >
        {floorplans.map((fp, index) => (
          <Carousel.Slide
            key={fp.modelId}
            ref={index === 0 ? carousel.firstSlide : undefined}
            slideAlign="start"
            className={styles.mobileCarouselItem}
          >
            <FloorPlanCard floorplan={fp} listing={listing} onUnitSelect={onUnitSelect} onSeeAll={onSeeAll} />
          </Carousel.Slide>
        ))}
      </Carousel.ScrollContainer>

      {floorplans.length > 1 && (
        <div className={styles.dotContainer}>
          <FloorPlanDots count={floorplans.length} current={currentSlide} onSelect={goToSlide} />
        </div>
      )}
    </>
  );
};
